import api from '../../api.js';

const TagEvent = {
  DISMISS: api.internals.ns.event('dismiss')
};

export { TagEvent };
